<template>
  <a-select
    v-model:value="selectValue"
    :not-found-content="null"
    :open="false"
    :dropdownRender="dropdownRender"
    :options="selectOptions"
    allow-clear
    showArrow
    v-bind="{ ...$attrs, ...selectMode }"
  >
  </a-select>
</template>
<script lang="ts" setup>
import { getSelectItem, treeGetItemFromSourceList } from '@/utils'
import type { ITreeSelectModalProps } from './xhTreeSelectWithModal/types'
import type { IValueType, IValueTypeMultiple } from '@/components/types'
import { useTreeDataMemory } from '@/hooks'
import type { DataNode } from 'ant-design-vue/es/tree'
import { isArray } from 'lodash-es'
import type { SelectProps } from 'ant-design-vue'
const checkedKeys = defineModel<IValueType>({
  required: true,
  default: undefined,
})

const props = defineProps<
  {
    multiple?: boolean
    treeDataDictionary?: DataNode[]
  } & Pick<ITreeSelectModalProps, 'treeData'>
>()

const selectMode = computed<Pick<SelectProps, 'mode' | 'labelInValue'>>(() => {
  if (!props.multiple)
    return {
      mode: undefined,
      labelInValue: false,
    }
  return {
    mode: 'multiple',
    labelInValue: true,
  }
})
const selectOptions = computed<SelectProps['options']>(() => {
  if (!checkedKeys.value || isArray(checkedKeys.value)) return undefined
  const currentSingleValue = checkedKeys.value
  const curItem = treeGetItemFromSourceList(currentSingleValue, [props.treeData, treeDataHistory, props.treeDataDictionary ?? []])
  if (curItem) {
    return [getSelectItem(curItem.key, curItem.title)]
  } else {
    return [getSelectItem(currentSingleValue)]
  }
})
// 自定义渲染下拉框内容
const dropdownRender = () => {
  return null
}
const treeDataRef = toRef(() => props.treeData)
const { treeDataHistory } = useTreeDataMemory(treeDataRef)
const selectValue = computed({
  get() {
    if (isArray(checkedKeys.value)) {
      return checkedKeys.value.map((item) => {
        const curItem = treeGetItemFromSourceList(item, [props.treeData, treeDataHistory, props.treeDataDictionary ?? []])
        if (curItem) {
          return getSelectItem(curItem.key, curItem.title)
        } else {
          return getSelectItem(item)
        }
      })
    } else {
      return checkedKeys.value
    }
  },
  set(val) {
    if (isArray(val)) {
      checkedKeys.value = val.map((i) => i.value) as IValueTypeMultiple
    } else {
      checkedKeys.value = val
    }
  },
})
</script>
